export { VpConditionalUpgradeWrapper } from './VpConditionalUpgradeWrapper';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpConditionalUpgradeWrapper/index.js